export const userTypes = [
  { value: "admin", label: "Admin" },
  { value: "superUser", label: "SuperUser" },
  { value: "user", label: "User" },
];
